import type { ColDef, ICellRendererParams } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'
import type { Menu } from '~/components/ActionMenu'
import type { IExternalLink } from '~/types/external-links'

import ActionMenu from '~/components/ActionMenu'
import TextCellRenderer from '~/components/CellRenderers/TextCellRenderer'
import { actionsColDef, textColDef } from '~/utils/table'

const ActionsCellRenderer = ({ context, data }: ICellRendererParams<IExternalLink>): ReactElement => {
  if (data) {
    const { handleDeleteExternalLink, handleEditExternalLink, handleRedirect } = context
    const { url } = data

    const menu: Menu = {
      actions: [
        {
          action: () => handleEditExternalLink(data),
          label: 'Edit',
        },
        {
          action: () => handleDeleteExternalLink(data),
          label: 'Delete',
        },
      ],
      navigations: [
        {
          action: () => handleRedirect(url),
          label: 'Open link',
          type: 'external',
        },
      ],
    }

    return <ActionMenu menu={menu} placement="top" />
  }

  return <div />
}

const columns: ColDef[] = [
  textColDef(TextCellRenderer, {
    field: 'target',
    headerName: 'Name',
    suppressMovable: true,
    width: 260,
  }),
  textColDef(TextCellRenderer, {
    field: 'url',
    headerName: 'Url',
    resizable: false,
    suppressMovable: true,
    width: 600,
  }),
  actionsColDef(ActionsCellRenderer, {
    field: 'actions',
  }),
]

export default columns
